import "../styles/Historia.css";
import Separator from "./Separator/separator";
import andreaGuion from "../assets/content/andrea_guion.png";

export default function Historia() {
  return (
    <section className="historia" id="historia">
      <div className="tit-sections mt-50">
        <h1>Conheça nossa história</h1>
        <Separator />
        <h2>"Uma trajetória de dedicação e excelência em odontologia"</h2>
      </div>
      <div className="historia-content">
        <div className="historia-imagem">
          <img 
            src={andreaGuion}
            alt="Dra. Andrea Guion - Fundadora" 
          />
          <div className="imagem-overlay">
            <h3>Dra. Andréa Fabiana Guion</h3>
          </div>
        </div>
        <div className="historia-texto">
          <div className="historia-timeline">
            <div className="timeline-item">
              <div className="ano">2009</div>
              <div className="conteudo">
                <h3>Início da Jornada</h3>
                <p>Nossa clínica foi fundada no Bairro de Pirituba, localizada na zona oeste de São Paulo, com o objetivo de oferecer atendimento odontológico de excelência e humanizado.</p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="ano">2023</div>
              <div className="conteudo">
                <h3>Nova Administração</h3>
                <p>Desde meados de 2023, a clínica vem sendo administrada pela Dra. Andréa Fabiana Guion, que mantém o compromisso com a excelência e o atendimento personalizado.</p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="ano">Presente</div>
              <div className="conteudo">
                <h3>Especialização e Atualização</h3>
                <p>Nossos profissionais são especializados em suas áreas de atuação, sendo graduados e pós-graduados em diferentes universidades e constantemente se atualizando através de cursos e congressos.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="historia-valores">
        <div className="valores-grid">
          <div className="valor-item">
            <span className="valor-icon material-icons">medical_services</span>
            <h4>Missão</h4>
            <p>Promover a saúde bucal personalizada e proporcionar a população, serviços odontológicos de excelência, com soluções práticas, individualizadas, confiáveis e cada vez mais completas e integradas. Criando desta forma vínculos fortes e duradouros com os nossos pacientes, funcionários e parceiros, sempre com comprometimento ético e responsabilidade social.</p>
          </div>
          <div className="valor-item">
            <span className="valor-icon material-icons">visibility</span>
            <h4>Visão</h4>
            <p>Tornar-se uma empresa de referência em qualidade, honestidade e transparência na prestação de serviços.</p>
          </div>
          <div className="valor-item">
            <span className="valor-icon material-icons">favorite</span>
            <h4>Valores</h4>
            <p>Nosso foco está em atender de forma individualizada cada paciente visando a satisfação, respeito, transparência, honestidade, comprometimento, profissionalismo, aperfeiçoamento profissional, gentileza, atendimento humanizado, vendo cada ser como único, nos comprometendo em entregar o melhor resultado para cada cliente.</p>
          </div>
        </div>
      </div>
    </section>
  );
} 